module.exports = __webpack_public_path__ + "img/734.24c20903.gif";